// Styles
import './BuilderConfigurationSidebar.scss';
import { ThemeConstants } from 'modules/shared/ThemeConstants';
import '!ng-cache-loader!./BuilderConfigurationVariablesView.html';
import '!ng-cache-loader!./BuilderConfigurationVersionsView.html';
import * as angular from 'angular';
import { v4 as uuid } from 'uuid';
import { CloseEditorIfOpenedEvent } from '../BuilderController';
import { GlobalTabIAction } from '../historyActions/GlobalTabIAction';
import { BuilderConfiguration, builderConfigurationVariablesFlowId } from './BuilderConfiguration';
import { BuilderConfigurationsSidebarFeatures } from './BuilderConfigurationsSidebarFeatures';
import { SUBFLOW_ID_PREFIX } from '../services/BuilderStateService';
import { SmartSalesConstants } from '../smartSales/SmartSalesConstants';
import { ToastType } from 'modules/application/misc/ToastService';
// Modals
import { ConfirmationModal } from 'modules/ui';
import AssignPublishedVersionNameModal from './modals/assignPublishedVersionName';
import { AgentState } from '../aiAgent/AiAgentConstants';
export const CHANGED_DELAY = 1500;
export class BuilderConfigurationSidebarController {
    static $inject = ['close', 'flow', 'flowId', 'configuration', 'secretConfiguration', 'globalActions', '$onChanged', 'LoadingService', '$timeout', 'FileSaver', 'application', 'BuilderService', 'BuilderSegmentService', 'ModalService', '$translate', 'ngToast', '$state', 'ChatService', '$rootScope', '$scope', 'SidebarContentService', 'UndoRedoService', 'SubflowService', 'CacheService', 'ApplicationService2', 'AccountService2', 'SmartSalesService', 'BlipToastService', 'BuilderAiAgentService', 'AiAgentSidebarStateService', 'BuilderTabsService'];
    constructor(close, flow, flowId, configuration, secretConfiguration, globalActions, $onChanged, LoadingService, $timeout, FileSaver, application, BuilderService, BuilderSegmentService, ModalService, $translate, ngToast, $state, ChatService, $rootScope, $scope, SidebarContentService, UndoRedoService, SubflowService, CacheService, ApplicationService2, AccountService2, SmartSalesService, BlipToastService, BuilderAiAgentService, AiAgentSidebarStateService, BuilderTabsService) {
        this.close = close;
        this.flow = flow;
        this.flowId = flowId;
        this.configuration = configuration;
        this.secretConfiguration = secretConfiguration;
        this.globalActions = globalActions;
        this.$onChanged = $onChanged;
        this.LoadingService = LoadingService;
        this.$timeout = $timeout;
        this.FileSaver = FileSaver;
        this.application = application;
        this.BuilderService = BuilderService;
        this.BuilderSegmentService = BuilderSegmentService;
        this.ModalService = ModalService;
        this.$translate = $translate;
        this.ngToast = ngToast;
        this.$state = $state;
        this.ChatService = ChatService;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.SidebarContentService = SidebarContentService;
        this.UndoRedoService = UndoRedoService;
        this.SubflowService = SubflowService;
        this.CacheService = CacheService;
        this.ApplicationService2 = ApplicationService2;
        this.AccountService2 = AccountService2;
        this.SmartSalesService = SmartSalesService;
        this.BlipToastService = BlipToastService;
        this.BuilderAiAgentService = BuilderAiAgentService;
        this.AiAgentSidebarStateService = AiAgentSidebarStateService;
        this.BuilderTabsService = BuilderTabsService;
        this.publishedVersionNameEditing = -1;
        // Needed to use {{ ... }} chars escaped in angular translate
        this.translateConfigDescriptionString = '{{config.VariableName}}';
        this.useConfigurationsApplication = false;
        this.isDeepChange = true;
        this.builderConfiguration = new BuilderConfiguration(this.configuration, () => this.raiseOnChanged(undefined), this.UndoRedoService, this.$translate, this.BuilderSegmentService, this.$rootScope, this.$timeout, this.secretConfiguration);
        this.init();
    }
    async init() {
        await this.checkFeatures();
        this.BuilderSegmentService.setApplication(this.application);
        this.BuilderTabsService.validateTab('content-tab-2', this.globalActions);
        // Remove the BLiP Chat Widget
        if (this.ChatService.built) {
            this.ChatService.destroy();
        }
        this.targetGlobalAction = this.globalActions;
        this.nameOfBlockUndoRedo = await this.$translate('builder-configurations.globalActions.title');
        this.$timeout(() => this.initializeProxy());
        if (!this.application.isSubflow) {
            this.fetchLatestPublishedVersions();
        }
    }
    async checkFeatures() {
        const isMainFlow = !this.application.isSubflow;
        this.isAiReliabilityEnabled = isMainFlow;
        this.isAutomaticTrackingEnabled = isMainFlow;
        this.isVersionsEnabled = true;
        this.isRollbackBuilderVerionEnabled = isMainFlow && await BuilderConfigurationsSidebarFeatures.isRollbackBuilderVersionEnabled();
        this.isGlobalActionsEnabled = isMainFlow && await BuilderConfigurationsSidebarFeatures.isGlobalActionsEnabled();
        this.isUseTunnelOwnerContextEnabled = isMainFlow && await BuilderConfigurationsSidebarFeatures.isUseTunnelOwnerContextEnabled();
        this.isStateExpirationEnabled = isMainFlow && await BuilderConfigurationsSidebarFeatures.isStateExpirationEnabled();
        this.isActionExecutionTimeoutEnabled = isMainFlow && await BuilderConfigurationsSidebarFeatures.isActionExecutionTimeoutEnabled();
        this.isOwnerIdentityEnabled = isMainFlow && await BuilderConfigurationsSidebarFeatures.isOwnerIdentityEnabled();
        this.isSubflowImportExportEnabled = await BuilderConfigurationsSidebarFeatures.isSubflowImportExportEnabled() || isMainFlow;
        this.useConfigurationsApplication = await BuilderConfigurationsSidebarFeatures.isUseConfigurationsDomainOnMiscOperationsGetEnabled();
    }
    async raiseOnChanged(data) {
        await this.$onChanged(this.globalActions);
    }
    async validateTab() {
        await this.BuilderTabsService.validateTab('content-tab-2', this.globalActions);
    }
    async exportFlow() {
        const agentStates = this.BuilderAiAgentService.getAgentStates(this.flow);
        await Promise.all(agentStates.map(async (state) => {
            state.$groundingConfig = await this.BuilderAiAgentService.getCatalogsWithDocuments(state.id, AgentState.DEVELOPMENT);
        }));
        const flowAndConfig = {
            flow: this.flow,
            globalActions: this.globalActions,
            subflows: await this.SubflowService.getEditedSubflowsOfFlow(this.flow),
        };
        const blob = new Blob([JSON.stringify(flowAndConfig)], { type: 'application/json;charset=utf-8' });
        this.FileSaver.saveAs(blob, `${this.application.shortName}.json`);
        this.trackConfigurationVersionDownloaded();
    }
    showFileDialog($event) {
        const pointerEvent = $event;
        if (pointerEvent && pointerEvent.clientX == 0) {
            // Hack to avoid IE11 loop
            return;
        }
        $event.stopPropagation();
        let element = $event.target;
        // Search for the input element recursivelly
        while (this.flowInput == undefined && element != undefined) {
            this.flowInput = angular.element(element).find('input')[0];
            if (!this.flowInput) {
                element = element.parentElement;
            }
        }
        if (this.flowInput) {
            this.$timeout(() => {
                this.flowInput.click();
            });
        }
    }
    async importFlow() {
        if (!this.flowFile || !this.flowFile.name) {
            return;
        }
        if (!this.flowFile.name.endsWith('.json')) {
            this.trackConfigurationVersionUploaded(false, 0);
            const invalidFlow = await this.$translate('builder-configurations.versions.invalidFlow');
            this.ngToast.danger(invalidFlow);
            return;
        }
        const fileReader = new FileReader();
        fileReader.onload = async (event) => {
            if (fileReader.readyState == fileReader.DONE && fileReader.result) {
                try {
                    const importJson = JSON.parse(fileReader.result);
                    const flow = (importJson.flow ? JSON.parse(typeof (importJson.flow) == 'object' ? JSON.stringify(importJson.flow) : importJson.flow) : importJson);
                    const globalActions = (importJson.globalActions ? JSON.parse(typeof (importJson.globalActions) == 'object' ? JSON.stringify(importJson.globalActions) : importJson.globalActions) : undefined);
                    const flowNumberBlocks = Object.keys(flow).length;
                    if (flow &&
                        flow.onboarding != undefined &&
                        flow.fallback != undefined) {
                        await this.confirmImportFlow(flow, globalActions, importJson?.subflows);
                    }
                    else {
                        this.trackConfigurationVersionUploaded(false, flowNumberBlocks);
                        const invalidFlow = await this.$translate('builder-configurations.versions.invalidFlow');
                        this.ngToast.danger(invalidFlow);
                    }
                }
                catch (e) {
                    this.trackConfigurationVersionUploaded(false, 0);
                    const invalidFlow = await this.$translate('builder-configurations.versions.invalidFlow');
                    this.ngToast.danger(invalidFlow);
                    console.error(e);
                }
                finally {
                    // Clear the input value to allow the use select the same file again (which does not trigger the ng-change event).
                    this.flowInput.value = '';
                }
            }
        };
        fileReader.readAsText(this.flowFile, 'UTF8');
    }
    async confirmImportFlow(flow, flowGlobalAction, newSubflows) {
        const modalTitle = await this.$translate('builder-configurations.versions.import');
        const modalBody = await this.$translate('builder-configurations.versions.importDisclaimer');
        const smartSalesError = await this.checkAndHandleSmartSalesError(flow);
        if (smartSalesError) {
            return;
        }
        // If the action is confirmed
        if (await this.showConfirmationModal(modalTitle, modalBody)) {
            const flowNumberBlocks = Object.keys(flow).length;
            this.LoadingService.startLoading(false);
            try {
                const currentImportedFlow = await this.validateImportedFlow(flow);
                if (!currentImportedFlow.isValidFlow) {
                    this.ngToast.danger(currentImportedFlow.message);
                    return;
                }
                await this.createNewSmartSales(flow);
                await this.createNewAiAgents(flow);
                await this.createNewSubflows(flow, newSubflows);
                await this.saveFlow(flow, flowGlobalAction);
                this.deleteSubflowsFromOldFlow(this.flow);
                this.trackConfigurationVersionUploaded(true, flowNumberBlocks);
            }
            catch (e) {
                this.trackConfigurationVersionUploaded(false, flowNumberBlocks);
                const importError = await this.$translate('builder-configurations.versions.importError');
                this.ngToast.danger(importError);
                console.error(e);
            }
            finally {
                this.LoadingService.stopLoading();
            }
            this.reloadPage();
        }
    }
    async validateImportedFlow(flow) {
        const isValidFlow = Object.keys(flow).some(value => value === 'end');
        if (this.application.isSubflow) {
            return {
                isValidFlow,
                message: await this.$translate('builder-configurations.versions.invalidSubFlow'),
            };
        }
        else {
            return {
                isValidFlow: !isValidFlow,
                message: await this.$translate('builder-configurations.versions.invalidFlow'),
            };
        }
    }
    async saveFlow(flow, flowGlobalAction) {
        if (this.application.isSubflow) {
            await this.SubflowService.setFlow(this.application.shortName, flow);
        }
        else {
            await this.BuilderService.setFlow(flow);
            //import globalActions
            if (flowGlobalAction) {
                await this.BuilderService.setGlobalActionsState(flowGlobalAction);
            }
        }
    }
    async restoreFlow() {
        const modalTitle = await this.$translate('builder-configurations.versions.restore');
        const modalBody = await this.$translate('builder-configurations.versions.restoreDisclaimer');
        const positiveAnswer = await this.$translate('builder-configurations.versions.restoreConfirmationModalPositiveAnswer');
        const negativeAnswer = await this.$translate('builder-configurations.versions.restoreConfirmationModalNegativeAnswer');
        // If the action is confirmed
        if (await this.showConfirmationModal(modalTitle, modalBody, positiveAnswer, negativeAnswer)) {
            this.LoadingService.startLoading(false);
            try {
                const publishedFlow = await this.BuilderService.getPublishedFlow();
                if (!publishedFlow) {
                    const errorMsg103 = await this.$translate('builder-configurations.versions.noPublishedVersion');
                    this.trackConfigurationLastVersionRestored(false);
                    this.ngToast.danger(errorMsg103);
                }
                else {
                    await this.restoreSubflowFromPublishedVersion(this.flow, publishedFlow);
                    await this.BuilderService.setFlow(publishedFlow);
                    const publishedConfiguration = await this.BuilderService.getPublishedFlowConfiguration();
                    if (publishedConfiguration) {
                        await this.BuilderService.setFlowConfiguration(publishedConfiguration);
                    }
                    this.trackConfigurationLastVersionRestored(true);
                }
            }
            catch (e) {
                this.trackConfigurationLastVersionRestored(false);
                const restoreError = await this.$translate('builder-configurations.versions.restoreError');
                this.ngToast.danger(restoreError);
                console.error(e);
            }
            finally {
                this.LoadingService.stopLoading();
            }
            this.reloadPage();
        }
    }
    async exportPublishedVersion(index) {
        const version = this.latestPublications.publications[index];
        try {
            const exportFlow = await this.BuilderService.getPublishedVersion(version.index);
            if (!exportFlow) {
                this.BuilderSegmentService.trackConfigurationLastVersionDownload({
                    VersionName: version.title || version.publishedAt,
                }, false);
                this.BlipToastService.show(ToastType.Danger, {
                    msg: await this.$translate('builder-configurations.versions.noPublishedVersion'),
                });
            }
            else {
                const flowJson = JSON.stringify(exportFlow);
                const blob = new Blob([flowJson], {
                    type: 'application/json;charset=utf-8',
                });
                this.FileSaver.saveAs(blob, `${version.title || this.application.shortName}_${new Date(version.publishedAt).toISOString()}.json`);
                this.BuilderSegmentService.trackConfigurationLastVersionDownload({
                    VersionName: version.title || version.publishedAt,
                }, true);
            }
        }
        catch (e) {
            this.BuilderSegmentService.trackConfigurationLastVersionDownload({
                VersionName: version.title || version.publishedAt,
            }, false);
            this.BlipToastService.show(ToastType.Danger, {
                msg: await this.$translate('builder-configurations.versions.restoreError'),
            });
            console.error(e);
        }
    }
    async restorePublishedVersion(index) {
        const version = this.latestPublications.publications[index];
        const modalTitle = await this.$translate('builder-configurations.versions.restore');
        const modalBody = await this.$translate('builder-configurations.versions.latestPublishedVersions.restoreDisclaimer', { date: version.publishedAt });
        const positiveAnswer = await this.$translate('builder-configurations.versions.restoreConfirmationModalPositiveAnswer');
        const negativeAnswer = await this.$translate('builder-configurations.versions.restoreConfirmationModalNegativeAnswer');
        // If the action is confirmed
        if (await this.showConfirmationModal(modalTitle, modalBody, positiveAnswer, negativeAnswer)) {
            this.LoadingService.startLoading(false);
            try {
                const publishedFlow = await this.BuilderService.getPublishedVersion(version.index);
                if (!publishedFlow) {
                    this.trackConfigurationVersionRestored(false, version.title || version.publishedAt);
                    this.BlipToastService.show(ToastType.Danger, {
                        msg: await this.$translate('builder-configurations.versions.noPublishedVersion'),
                    });
                }
                else {
                    const { isValidFlow, message } = await this.validateImportedFlow(publishedFlow.flow);
                    if (!isValidFlow) {
                        this.BlipToastService.show(ToastType.Danger, {
                            msg: message,
                        });
                        return;
                    }
                    await this.restoreSubflowFromPublishedVersion(this.flow, publishedFlow.flow);
                    await this.BuilderService.setFlow(publishedFlow.flow);
                    await this.BuilderService.setFlowConfiguration(publishedFlow.configuration);
                    this.trackConfigurationVersionRestored(true, version.title || version.publishedAt);
                }
            }
            catch (e) {
                this.trackConfigurationVersionRestored(true, version.title || version.publishedAt);
                this.BlipToastService.show(ToastType.Danger, {
                    msg: await this.$translate('builder-configurations.versions.restoreError'),
                });
                console.error(e);
            }
            finally {
                this.LoadingService.stopLoading();
            }
            this.reloadPage();
        }
    }
    async restoreSubflowFromPublishedVersion(currentFlow, publishedFlow) {
        const activitySubflowsShortName = this.getSubflowsShortNameFromFlow(currentFlow);
        const retorePublishedSubflowsShortName = this.getSubflowsShortNameFromFlow(publishedFlow);
        for (const retoreSubflow of retorePublishedSubflowsShortName) {
            if (!activitySubflowsShortName.includes(retoreSubflow)) {
                await this.SubflowService.changeActive(retoreSubflow, true);
            }
        }
        for (const activitySubflow of activitySubflowsShortName) {
            if (!retorePublishedSubflowsShortName.includes(activitySubflow)) {
                await this.SubflowService.changeActive(activitySubflow, false);
            }
        }
    }
    async fetchLatestPublishedVersions() {
        this.latestPublications = await this.BuilderService.getLatestPublications();
    }
    async showConfirmationModal(modalTitle, modalBody, positiveAnswer = undefined, negativeAnswer = undefined) {
        positiveAnswer = positiveAnswer ?? await this.$translate('utils.misc.yes');
        negativeAnswer = negativeAnswer ?? await this.$translate('utils.misc.no');
        const modal = await this.ModalService.showModal(ConfirmationModal({
            title: {
                text: modalTitle,
            },
            body: modalBody,
            buttons: {
                confirm: {
                    text: positiveAnswer,
                },
                cancel: {
                    text: negativeAnswer,
                },
            },
            theme: ThemeConstants.DARK,
        }));
        return await modal.close;
    }
    async closeSidebar() {
        try {
            if (!this.ChatService.built) {
                this.ChatService.build();
            }
            this.$rootScope.$broadcast(CloseEditorIfOpenedEvent);
            await this.close();
        }
        catch (e) {
            console.error(e);
        }
    }
    async confirmResetFlowId() {
        const modalTitle = await this.$translate('builder-configurations.variables.flowId.reset');
        const modalBody = await this.$translate('builder-configurations.variables.flowId.resetDisclaimer');
        // If the action is confirmed
        if (await this.showConfirmationModal(modalTitle, modalBody)) {
            this.LoadingService.startLoading(false);
            try {
                this.flowId = uuid();
                await this.BuilderService.setFlowId(this.flowId);
                this.reloadPage();
            }
            catch (e) {
                const importError = await this.$translate('builder-configurations.variables.flowId.resetError');
                this.ngToast.danger(importError);
                console.error(e);
            }
            finally {
                this.BuilderSegmentService.trackVariablesAutoTracking(builderConfigurationVariablesFlowId, { FlowIdReset: true, flowId: this.flowId }, true);
                this.LoadingService.stopLoading();
            }
        }
    }
    handleGlobalActionsChanges(type, value) {
        const isValidActionChange = this.cleanUnecessaryActions(value); //removing invalid actions #215023
        const actionType = angular.copy(this.globalActions[type]).length < value.length ? 'add' : 'delete';
        const a = angular.copy(this.globalActions[type]);
        const b = angular.copy(value);
        const diff = a.length > b.length ? //gets the difference between 2 values, in this case the modified value
            this.getGlobalActionDifference(a, b) :
            this.getGlobalActionDifference(b, a);
        if (!this.isGlobalActionsEnabled || !isValidActionChange || !diff) {
            return;
        }
        const segmentPayload = {
            actionType: actionType,
            contentType: diff[0]?.$title,
        };
        const changeContentTabIAction = new GlobalTabIAction({
            execute: (data) => {
                const isValidActionChange = this.cleanUnecessaryActions(data.after);
                if (!isValidActionChange) {
                    return;
                }
                this.globalActions[type] = data.after;
                data.after.forEach(item => {
                    item.settings = item.settings || {};
                });
                this.validateTab();
                this.validateAndSaveState();
                this.trackBlockConfigurationRedo(true, segmentPayload);
            },
            undo: (data) => {
                const isValidActionChange = this.cleanUnecessaryActions(data.before);
                if (!isValidActionChange) {
                    return;
                }
                this.globalActions[type] = data.before;
                this.validateTab();
                this.validateAndSaveState();
                this.trackBlockConfigurationUndo(true, segmentPayload);
                /*
                * It has been created an validation which if the data after is greather than
                * data before (length), it's happening a block exclusion action, so, we
                * filter the opened sideabars to filter sidebars which is an Action Sidebar
                * and we use the method to close it.
                */
                const openedSidebarsIds = this.SidebarContentService.getSidebars().map(({ sidebarId }) => sidebarId).filter(s => s != undefined);
                if (openedSidebarsIds) {
                    const actionsId = this.globalActions.id;
                    openedSidebarsIds?.forEach(openedSidebarId => {
                        if (!actionsId.includes(openedSidebarId)) {
                            const sidebarToBeClosed = this.SidebarContentService
                                .getSidebars()
                                .find(({ sidebarId }) => sidebarId == openedSidebarId);
                            this.SidebarContentService.cleanAndClose(undefined, sidebarToBeClosed);
                        }
                    });
                }
            },
            data: {
                after: angular.copy(value),
                before: angular.copy(this.globalActions[type]),
                state: {
                    id: this.nameOfBlockUndoRedo,
                    $title: this.nameOfBlockUndoRedo,
                },
            },
        });
        this.UndoRedoService.add(changeContentTabIAction);
    }
    cleanUnecessaryActions(value) {
        let isValidActionChange = true;
        if (!value) {
            return;
        }
        value = value.filter(item => {
            if (!item) {
                isValidActionChange = false;
            }
            return item !== undefined;
        });
        return isValidActionChange;
    }
    getGlobalActionDifference(a, b) {
        return a.filter(x => !b.some(y => x?.$id === y?.$id));
    }
    initializeProxy() {
        this.globalActions = new Proxy(this.targetGlobalAction, {
            set: (target, key, value) => {
                switch (key) {
                    case 'this.globalActions.$enteringCustomActions':
                        this.handleGlobalActionsChanges(key, value);
                        break;
                    case 'this.globalActions.$leavingCustomActions':
                        this.handleGlobalActionsChanges(key, value);
                        break;
                    default:
                        // just pass through
                        break;
                }
                return Reflect.set(target, key, value);
            },
        });
    }
    async validateAndSaveState() {
        this.oldGlobalActions = { ...this.globalActions };
        await this.$onChanged(this.globalActions);
    }
    // Segment Methods
    trackConfigurationLastVersionRestored(success) {
        this.BuilderSegmentService.trackConfigurationLastVersionRestored({}, success);
    }
    trackConfigurationVersionRestored(success, versionName) {
        this.BuilderSegmentService.trackConfigurationVersionRestored({
            VersionName: versionName.toString(),
        }, success);
    }
    trackConfigurationVersionUploaded(success, numberBlocks) {
        const payload = { NumberBlocks: numberBlocks };
        if (!this.application.isSubflow) {
            this.BuilderSegmentService.trackConfigurationVersionUploaded(payload, success);
        }
        else {
            this.BuilderSegmentService.trackSubflowConfigurationVersionUploaded(payload, success);
        }
    }
    trackConfigurationVersionDownloaded() {
        const payload = { NumberBlocks: Object.keys(this.flow).length };
        if (!this.application.isSubflow) {
            this.BuilderSegmentService.trackConfigurationVersionDownloaded(payload, true);
        }
        else {
            this.BuilderSegmentService.trackSubflowConfigurationVersionDownloaded(payload, true);
        }
    }
    trackConfigurationVariablesAutoTrackingEnabled() {
        this.BuilderSegmentService.trackConfigurationVariablesAutoTrackingEnabled({
            NumberBlocks: Object.keys(this.flow).length,
        }, true);
    }
    trackConfigurationVariablesAutoTrackingDisabled() {
        this.BuilderSegmentService.trackConfigurationVariablesAutoTrackingDisabled({
            NumberBlocks: Object.keys(this.flow).length,
        }, true);
    }
    trackConfigurationVariablesAiConfiabilityDefined() {
        this.BuilderSegmentService.trackConfigurationVariablesAiConfiabilityDefined({
            ConfiabilityValue: this.builderConfiguration.action.minimumIntentScore,
        }, true);
    }
    trackBlockActionUndo(success, segmentPayload) {
        this.BuilderSegmentService.trackBlockActionUndo(segmentPayload, success);
    }
    trackBlockActionRedo(success, segmentPayload) {
        this.BuilderSegmentService.trackBlockActionRedo(segmentPayload, success);
    }
    trackBlockConfigurationUndo(success, segmentPayload) {
        this.BuilderSegmentService.trackBlockConfigurationUndo(segmentPayload, success);
    }
    trackBlockConfigurationRedo(success, segmentPayload) {
        this.BuilderSegmentService.trackBlockConfigurationRedo(segmentPayload, success);
    }
    trackConfigurationVariablesAdded() {
        this.BuilderSegmentService.trackConfigurationVariablesAdded({}, true);
    } // Used on VariablesView
    trackSecretConfigurationVariablesAdded() {
        this.BuilderSegmentService.trackSecretConfigurationVariablesAdded({}, true);
    } // Used on VariablesView
    trackConfigurationVariablesRemoved(variableName) {
        this.BuilderSegmentService.trackConfigurationVariablesRemoved({
            VariableName: variableName,
        }, true);
    } // Used on VariablesView
    trackSecretConfigurationVariablesRemoved(variableName) {
        this.BuilderSegmentService.trackSecretConfigurationVariablesRemoved({
            VariableName: variableName,
        }, true);
    } // Used on VariablesView
    async onToggleActivePublishedVersions(payload) {
        if (!payload || !payload.isActive) {
            return;
        }
        this.BuilderSegmentService.trackConfigurationLastVersionOpened();
    }
    reloadPage() {
        this.removeApplicationCache();
        this.$state.reload();
    }
    removeApplicationCache() {
        const applicationCaller = this.application.isSubflow && this.application.callerApplication ? `:${this.application.callerApplication.shortName}` : '';
        const identifier = this.application.shortName + applicationCaller;
        this.CacheService.delete(identifier);
    }
    getSubflowsShortNameFromFlow(flow) {
        return Object.entries(flow).map(([key, value]) => {
            if (key.includes(SUBFLOW_ID_PREFIX)) {
                return value.shortNameOfSubflow;
            }
        }).filter(item => item);
    }
    async createNewSubflows(flow, subflows) {
        if (subflows?.length) {
            const { extras: { tenantId } } = await this.ApplicationService2.getAccount();
            const { email } = await this.AccountService2.me();
            for (const subflow of subflows) {
                const config = await this.SubflowService.getSubflowConfigurationOrDefault(subflow.shortName, flow);
                const subflowConfiguration = {
                    ...config,
                    userIdentity: email,
                    tenantId,
                    isShared: false,
                };
                delete subflowConfiguration.shortName;
                const flowOfSubflow = subflow.flow ? subflow.flow : await this.SubflowService.getEditedFlowOfSubflow(subflow.shortName, undefined);
                const newSubflow = await this.SubflowService.createNewSubflow(subflowConfiguration, flowOfSubflow, subflow.configuration);
                Object.keys(flow).forEach(key => {
                    if (flow[key]?.shortNameOfSubflow == subflow.shortName) {
                        flow[key].shortNameOfSubflow = newSubflow.shortName;
                    }
                });
                subflow.shortName = newSubflow.shortName;
            }
        }
    }
    async deleteSubflowsFromOldFlow(flow) {
        const oldSubflowsToDisable = Object.keys(flow).filter(key => key.includes(SUBFLOW_ID_PREFIX));
        if (oldSubflowsToDisable.length) {
            for (const oldSubflowKey of oldSubflowsToDisable) {
                try {
                    await this.SubflowService.changeActive(flow[oldSubflowKey].shortNameOfSubflow, false);
                }
                catch (e) {
                    console.error(e);
                }
            }
        }
    }
    async createNewSmartSales(flow) {
        if (this.smartSalesOwner) {
            const smartSalesStates = Object.values(flow).filter(state => state.id.startsWith(SmartSalesConstants.STATE_ID_PREFIX));
            if (smartSalesStates.length) {
                for (const smartSalesState of smartSalesStates) {
                    const idToDelete = smartSalesState.id;
                    const state = this.SmartSalesService.mergeSmartSalesState(await this.SmartSalesService.createSmartSalesState(), smartSalesState);
                    flow[state.id] = state;
                    this.ChangeOutputConditionsFromTheOldBlockToTheNewOne(flow, idToDelete, state.id);
                    delete flow[idToDelete];
                    const { identity } = await this.ApplicationService2.getAccount();
                    this.SmartSalesService.setSmartSalesStateInformation({
                        flowIdentifier: this.flowId,
                        botIdentifier: identity,
                        stateId: state.id,
                    });
                }
            }
        }
    }
    // This method is a placeholder for the logic to create AI Agents based on the imported flow.
    async createNewAiAgents(flow) {
        const aiAgentStates = this.BuilderAiAgentService.getAgentStates(flow);
        if (aiAgentStates.length) {
            for (const aiAgentState of aiAgentStates) {
                // Extracting the AI Agent configuration from the state and send to Apa to create agent on new bot
                await this.BuilderAiAgentService
                    .publishAgentConfiguration(aiAgentState, AgentState.DEVELOPMENT);
            }
        }
    }
    ChangeOutputConditionsFromTheOldBlockToTheNewOne(flow, oldStateId, newStateId) {
        Object.keys(flow).forEach(key => {
            flow[key].$conditionOutputs?.forEach(output => {
                if (output.stateId === oldStateId) {
                    output.stateId = newStateId;
                }
            });
            if (flow[key].$defaultOutput.stateId === oldStateId) {
                flow[key].$defaultOutput.stateId = newStateId;
            }
        });
    }
    async checkAndHandleSmartSalesError(flow) {
        const smartSalesState = Object.values(flow).find(state => {
            return state.id.startsWith(SmartSalesConstants.STATE_ID_PREFIX);
        });
        if (smartSalesState) {
            const owner = await this.SmartSalesService.getSmartSalesOwner(this.useConfigurationsApplication);
            if (!owner) {
                this.BlipToastService.show(ToastType.Danger, {
                    title: await this.$translate('builder.smartSales.error.import.title'),
                    msg: await this.$translate('builder.smartSales.error.import.body'),
                    buttonText: await this.$translate('builder.smartSales.error.import.button'),
                    callback: async () => await this.SmartSalesService.redirectToInstallPlugin(),
                });
                return true;
            }
            this.smartSalesOwner = owner;
        }
        return false;
    }
    shouldWrapPublishedVersionMenu(index) {
        const elements = document.querySelectorAll('#latest-published-versions-content');
        const element = elements[index];
        if (element) {
            const height = element.clientHeight;
            return height >= 143.94;
        }
        else {
            return false;
        }
    }
    async assignPublishedVersionName(index) {
        // Tracking
        this.BuilderSegmentService.trackConfigurationLastVersionName(this.application);
        const version = this.latestPublications.publications[index];
        const modal = await this.ModalService.showModal(AssignPublishedVersionNameModal({
            confirm: async (title, description) => {
                // Tracking
                this.BuilderSegmentService.trackBuilderSavedActionVersion(this.application);
                version.title = title;
                version.description = description;
                await this.BuilderService.updatePublicationByIndex(index, version);
            },
            title: version.title,
            description: version.description,
        }));
        return await modal.close;
    }
    isModalOpen(modalId) {
        return this.AiAgentSidebarStateService.isOpen(modalId);
    }
}
BuilderConfigurationSidebarController.$inject = ['close', 'flow', 'flowId', 'configuration', 'secretConfiguration', 'globalActions', '$onChanged', 'LoadingService', '$timeout', 'FileSaver', 'application', 'BuilderService', 'BuilderSegmentService', 'ModalService', '$translate', 'ngToast', '$state', 'ChatService', '$rootScope', '$scope', 'SidebarContentService', 'UndoRedoService', 'SubflowService', 'CacheService', 'ApplicationService2', 'AccountService2', 'SmartSalesService', 'BlipToastService', 'BuilderAiAgentService', 'AiAgentSidebarStateService', 'BuilderTabsService'];
